import React from 'react';
import { Section } from './ui/Section';
export function ProductOverview() {
  const pillars = [{
    title: 'Autopsia',
    subtitle: 'de tu Baño'
  }, {
    title: 'La Matriz',
    subtitle: 'de Activos'
  }, {
    title: 'El Protocolo',
    subtitle: 'Reset'
  }, {
    title: 'Reconstrucción',
    subtitle: 'Inteligente'
  }, {
    title: 'Tu Piel',
    subtitle: 'Para Siempre'
  }];
  return <Section data-id="element-205">
      <div className="text-center mb-12" data-id="element-206">
        <h2 className="font-display text-3xl md:text-5xl font-bold mb-4 text-brand-title" data-id="element-207">
          🏆 El sistema científico de skincare más completo para mujeres en
          España
        </h2>
        <p className="font-heading text-xl md:text-2xl text-brand-cta font-bold mb-3" data-id="element-208">
          🧴 EL AUDITOR DE SKINCARE™
        </p>
        <p className="font-body text-brand-subtitle text-lg font-medium" data-id="element-209">
          5 tomos + 3 bonos estratégicos. Todo listo para aplicar desde hoy.
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-4" data-id="element-210">
        {pillars.map((pillar, i) => <div key={i} className="bg-white border border-neutral-200 rounded-xl p-6 text-center shadow-sm hover:border-brand-cta/50 transition-colors w-full md:w-auto md:flex-1 min-w-[150px]" data-id="element-211">
            <div className="font-heading text-brand-title font-bold mb-1 text-[16px]" data-id="element-212">
              {pillar.title}
            </div>
            <div className="font-body text-brand-subtitle text-sm" data-id="element-213">
              {pillar.subtitle}
            </div>
          </div>)}
      </div>
    </Section>;
}